import { useState, useCallback, useEffect } from "react"
import deepEqual from "fast-deep-equal/react"

export const useFunctions = (initialData = {}) => {
  const [data, setData] = useState(initialData)
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState<Array<string>>([])

  const handleChange = ({ target: { type, name, value, checked } }: React.ChangeEvent<HTMLInputElement>) => {
    setData(prevState => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value,
    }))
  }

  // Re-render the hook if initialData changes
  useEffect(() => {
    const initialDataChanged = !deepEqual(initialData, data)
    const dataIsEmpty = Object.keys(data).length === 0
    if (initialDataChanged && dataIsEmpty) setData(initialData)
  }, [initialData, data])

  const callFunction = useCallback(async (name, data, method = "POST") => {
    try {
      setLoading(true)
      setErrors([])

      const response = await fetch(`/api/${name}`, {
        method,
        ...(data
          ? {
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            }
          : {}),
      })
      const body = await response.json()

      setLoading(false)

      if (body.status === "error") {
        setErrors([body.body])
        return body
      }
      return { ...body }
    } catch (err) {
      setLoading(false)
      setErrors([(err as Error).message])
      return { status: "error", body: (err as Error).message }
    }
  }, [])

  return { callFunction, loading, errors, data, handleChange }
}
